import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerService } from '../shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RecommendationsFormComponent } from '../customers/community/recommandations-form/recommandations-form.component';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SharedService } from '../shareModule/services/shared.service';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { PopUpService } from '../popupservice.service';

@Component({
  selector: 'app-add-comparision-article',
  templateUrl: './add-comparision-article.component.html',
  styleUrl: './add-comparision-article.component.scss',
})
export class AddComparisionArticleComponent implements OnInit, OnDestroy {
  public readonly MAX_SELECTED_PRODUCT = 3
  
  public searchString = '';
  public products = [];
  public recommendedProducts = [];
  public selectedProducts = [];
  public currentPageNum = 1;
  public reasons = ['', '', ''];

  private _destroyed = new Subject();
 


  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private local: LocalServiceService,
    private popup: PopUpService
  ) {}


  public ngOnDestroy(): void {
    this._destroyed.complete();
  }

  public get totalAttachedProductsNum(){
    return this.recommendedProducts.length + this.selectedProducts.length
  }
  public ngOnInit(): void {
    this.sharedService.addedNewRecommendation
      .pipe(takeUntil(this._destroyed))
      .subscribe((data) => {
        console.log({data})
        if(this.totalAttachedProductsNum == this.MAX_SELECTED_PRODUCT){
          return;
       }
        this.recommendedProducts.push(data);
      });
    this.getProducts();
  }
  closeModal() {}

  public removeRecomm(recomm){
    this.recommendedProducts.splice(this.recommendedProducts.indexOf(recomm), 1)
  }

  public goToPage(pageNum){
    if(this.currentPageNum == 1 && this.totalAttachedProductsNum < 3){
      this.toastr.info("Please recommend/select at least 3 products");
      return;
    }
    this.currentPageNum = pageNum;

  }

  public isSelected(product){
    return !!this.selectedProducts.find(prod => prod.id == product.id)
  }
  public get allAttached(){
    return [...this.selectedProducts, ...this.recommendedProducts]
  }
  public selectProduct(product) {

    const indexOfPastSelected = this.selectedProducts.findIndex(prod => prod.id == product.id)
    if (indexOfPastSelected != -1) {
      this.selectedProducts.splice(
        indexOfPastSelected,
        1,
      );
    } else {
      this.selectedProducts.push(product);
    }
    if (this.selectedProducts.length > 3) {
      this.selectedProducts.splice(0, 1);
    }

    //console.log({product}, this.selectedProducts)
    this.cdr.detectChanges();
  }
  public openRecommendation() {
    if(this.totalAttachedProductsNum == this.MAX_SELECTED_PRODUCT){
      this.local.alertInfo({title:'', message:"Maximum Product/Recommendation Reached"});
      return;
   }
    // this.modalService.open(RecommendationsFormComponent, { size: 'md' });
    this.popup.openPopup(RecommendationsFormComponent, {modalSize:'md'})
  }
  public getProducts() {
    this.customerService
      .getMemberShopProductList({ search: this.searchString, limit: 1010 })
      .subscribe({
        next: (data) => {
          this.products = data.body.data;
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error loading products');
        },
      });
  }
}
